import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SecurityService } from '../../security/services/security.service';
import { CommonValidators } from '../../lib/validators/common.validators';
import { Password } from '../password/password.model';
import { Router } from '@angular/router';
import { NotificationService } from '../../notifications/notification.service';
import { NotificationType } from '../../notifications/notification.model';
import { User } from '../../users/model/user.model';
import { APP_ROUTES } from 'src/app/app-routing.const';
import { notify } from '../../utils/function/notification.util';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})
export class RegistrationComponent {

  userDetails?: User;

  constructor(private formBuilder: FormBuilder,
              private securityService: SecurityService,
              private notificationService: NotificationService,
              private router: Router) {
  }

  register(password: Password) {
    this.securityService.register({
      email: this.userDetails?.email!!,
      password: password.newPassword
    })
    .subscribe(_ => {
      notify(this.notificationService, NotificationType.SUCCESS, 'register.notification.creation-success');
      this.router.navigate([APP_ROUTES.AUTH.LOGIN]);
    });
  }

  onUserDetails(userDetails: User) {
    this.userDetails = userDetails;
  }
}
